import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { debounce } from 'lodash';
import { ClientService } from 'src/app/api/sale/client.service';
import * as _ from 'underscore';
declare var $: any;

@Component({
  selector: 'component-search-client',
  templateUrl: './search-client.component.html',
  styleUrls: ['./search-client.component.css']
})
export class SearchClientComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @Output() selectedClientEvent = new EventEmitter<string>();
  @Input() classSize: string | null = null;

  data = [];
  keyword = 'fullname_str';
  isTypedSearch = false;
  classSearch:any;

  constructor(private clientService: ClientService) {
  }

  ngOnInit() {
    this.classSearch = this.classSize; 
  }

  debouncedSearchInput = debounce(event => this.getSearchTours(event), 250);

  getSearchTours(search_: any) {
    this.isTypedSearch = true;
    if (search_.length > 1) {
      let val_params = 'search=' + search_;
      this.clientService.search(val_params).subscribe({
        next: (data: any) => {
          this.data = data.results;
          this.data.map((item:any) => item.fullname_str = `${item.fullname} ${item.document}`);
        }
      });
    } else {
      this.data = [];
    }
  }

  selectSearchClient(item: any) {
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
      (<any>$('.autocomplete-container .not-found')).hide();
    }, 10);
    
    this.selectedClientEvent.emit(item);
    this.data = [];
    // this.searchInput.clear();
    // this.searchInput.focus();
  }

  closedSearchPanel(): void {
    this.data = [];
    // this.searchInput.clear();
    // this.searchInput.focus();
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  clearedInputSearch(): void {
    this.searchInput.focus();    
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  focused() {
    this.searchInput.focus(); 
  }
}
